import { handleActions, combineActions } from 'redux-actions';
import { SET_NAV_NODE, SET_EXPIRENCE_TYPE, LOAD_NAV_DATA } from './constants';

const initialState = {
  loading: false,
  error: false,
  model: [],
  currentNode: {
    code: '',
    appBehavior: {},
    childs: [],
  },
  isNewNavigationExperience: false,
};

const navigationReducer = handleActions(
  {
    [combineActions(LOAD_NAV_DATA.PENDING, LOAD_NAV_DATA.BOOT)]: state => ({
      ...state,
      loading: true,
      error: false,
    }),
    [combineActions(
      LOAD_NAV_DATA.CANCELLED,
      LOAD_NAV_DATA.SUCCESS,
      LOAD_NAV_DATA.ERROR,
    )]: state => ({
      ...state,
      loading: false,
    }),
    [LOAD_NAV_DATA.SUCCESS]: (state, { payload }) => ({
      ...state,
      model: payload || state.model,
      error: false,
    }),
    [LOAD_NAV_DATA.ERROR]: state => ({
      ...state,
      error: true,
    }),
    [SET_NAV_NODE]: (state, { payload }) => ({
      ...state,
      currentNode: { ...state.currentNode, ...payload },
    }),
    [SET_EXPIRENCE_TYPE]: (state, { payload }) => ({
      ...state,
      isNewNavigationExperience: payload,
    }),
  },
  initialState,
);

export default navigationReducer;
